import { CouponType as gqlCouponType } from '@app/types/cart-bff/types';
import { CouponType } from './cart';
import {
  ApplyCouponAPIResponse,
  ApplyCouponAPISuccess,
  RemoveCouponAPIResponse,
  RemoveCouponAPISuccess,
  UpdateLineItemAPIResponse,
  UpdateLineItemAPISuccess,
} from './types';

export const mapCouponType = (type: gqlCouponType): CouponType => {
  const map: Record<gqlCouponType, CouponType> = {
    [gqlCouponType.Amount]: 'AmountCoupon',
    [gqlCouponType.FreeSample]: 'FreeSampleCoupon',
    [gqlCouponType.FreeShipping]: 'FreeShippingCoupon',
    [gqlCouponType.GiftCertificate]: 'GiftCertificateCoupon',
    [gqlCouponType.PercentOff]: 'PercentOffCoupon',
    [gqlCouponType.VariablePercentOff]: 'VariablePercentOffCoupon',
  };
  return map[type];
};

export const isUpdateLineItemAPISuccess = (
  response: UpdateLineItemAPIResponse
): response is UpdateLineItemAPISuccess => 'cart' in response;

export const isApplyCouponAPISuccess = (
  response: ApplyCouponAPIResponse
): response is ApplyCouponAPISuccess => 'cart' in response;

export const isRemoveCouponAPISuccess = (
  response: RemoveCouponAPIResponse
): response is RemoveCouponAPISuccess => 'cart' in response;
